/*
 * Copyright (c) 2023. American Express Company
 */

// third-party
import React from 'react';

// models and services
import { OnboardingHeaderViewModel } from 'src/types/view-models/onboarding/onboarding-header.view.model';

// components
import OnboardingProgress from 'src/components/atomic/molecules/onboardingProgress/OnboardingProgress';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

// icons and styles
import styles from './OnboardingHeader.module.scss';
import useDocumentTitle from 'src/hooks/useDocumentTitle';

export default function OnboardingHeader({
    title,
    description,
    onboardingStep
}: OnboardingHeaderViewModel): JSX.Element {
    useDocumentTitle(title);

    return (
        <div className={styles.onboardingHeader}>
            <OnboardingProgress index={onboardingStep} length={7} />
            {title && (
                <Typography variant={TypographyVariants.HEADING_S} className={styles.onboardingHeaderTitle}>
                    {title}
                </Typography>
            )}
            <Typography variant={TypographyVariants.BODY}>{description}</Typography>
        </div>
    );
}
